import * as React from 'react';
import { Link } from 'react-router-dom';

interface Props {
  url: string;
  name: string;
  preview: string;
}

export default class extends React.Component<Props> {
  state = {
    isOver: false
  };
  didEnter = () => {
    this.setState({ isOver: true });
  };
  didLeave = () => {
    this.setState({ isOver: false });
  };
  render() {
    const url =
      this.state.isOver && this.props.preview
        ? this.props.preview
        : this.props.url;
    return (
      <div
        className="example-thumb"
        onMouseEnter={this.didEnter}
        onMouseLeave={this.didLeave}
      >
        <Link to={'/examples/' + this.props.name} replace={true}>
          <img
            title={this.props.name}
            alt={this.props.name}
            src={url}
            // crossOrigin="anonymous"
            draggable={false}
          />
        </Link>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/examples/ExampleThumb.tsx